import React from 'react'

const planConfig = {
  free:       { label: 'Free',       className: 'plan-free' },
  emerging:   { label: 'Emerging',   className: 'plan-emerging' },
  creator:    { label: 'Creator',    className: 'plan-creator' },
  pro:        { label: 'Pro',        className: 'plan-pro' },
  studio:     { label: 'Studio',     className: 'plan-studio' },
  enterprise: { label: 'Enterprise', className: 'plan-enterprise' },
}

export default function PlanBadge({ plan }) {
  const config = planConfig[plan] || planConfig.free
  return <span className={`plan-badge ${config.className}`}>{config.label}</span>
}
